import { render } from "./Socialmedia.vue?vue&type=template&id=b03b06a8"
import script from "./Socialmedia.vue?vue&type=script&lang=js"
export * from "./Socialmedia.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__